/**
 * Coure.Hub.Service.Creation
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ServiceBillingMode } from './serviceBillingMode';
import { ServiceBillingType } from './serviceBillingType';

export interface VasServiceRevenueShareDetailsModel { 
    id?: string;
    serviceId?: string;
    deliveryPartner?: string;
    revenueShareDeliveryPartner?: number;
    serviceProviderRevenueShare?: number;
    telco?: string;
    serviceFee?: string;
    revenueShareTelco?: number;
    contentPartner?: string;
    revenueShareContentPartner?: number;
    serviceBillingMode?: ServiceBillingMode;
    serviceBillingType?: ServiceBillingType;
    tenantId?: string;
}